"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _dropDown = _interopRequireDefault(require("@clayui/drop-down"));

var _form = _interopRequireWildcard(require("@clayui/form"));

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _label = _interopRequireDefault(require("@clayui/label"));

var _layout = _interopRequireDefault(require("@clayui/layout"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["ariaLabels", "helpText", "id", "label", "locales", "onSelectedLocaleChange", "onTranslationsChange", "placeholder", "prependContent", "resultFormatter", "selectedLocale", "spritemap", "translations"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ClayLocalizedInput = /*#__PURE__*/_react.default.forwardRef(function (_ref, ref) {
  var _ref$ariaLabels = _ref.ariaLabels,
      ariaLabels = _ref$ariaLabels === void 0 ? {
    default: 'Default',
    openLocalizations: 'Open Localizations',
    translated: 'Translated',
    untranslated: 'Untranslated'
  } : _ref$ariaLabels,
      helpText = _ref.helpText,
      id = _ref.id,
      _ref$label = _ref.label,
      label = _ref$label === void 0 ? 'Check for translations' : _ref$label,
      locales = _ref.locales,
      onSelectedLocaleChange = _ref.onSelectedLocaleChange,
      onTranslationsChange = _ref.onTranslationsChange,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'Text to translate...' : _ref$placeholder,
      prependContent = _ref.prependContent,
      _ref$resultFormatter = _ref.resultFormatter,
      resultFormatter = _ref$resultFormatter === void 0 ? function (val) {
    return val;
  } : _ref$resultFormatter,
      selectedLocale = _ref.selectedLocale,
      spritemap = _ref.spritemap,
      translations = _ref.translations,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      active = _React$useState2[0],
      setActive = _React$useState2[1];

  var defaultLanguage = locales[0];
  return /*#__PURE__*/_react.default.createElement(_form.default.Group, null, label && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id
  }, label), helpText && /*#__PURE__*/_react.default.createElement(_form.default.Text, null, helpText), /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, null, prependContent && /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    prepend: true,
    shrink: true
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupText, null, prependContent)), /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    append: prependContent ? true : false
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput, _extends({}, otherProps, {
    id: id,
    onChange: function onChange(event) {
      onTranslationsChange(_objectSpread(_objectSpread({}, translations), {}, _defineProperty({}, selectedLocale.label, event.target.value)));
    },
    placeholder: placeholder,
    ref: ref,
    type: "text",
    value: translations[selectedLocale.label] || ''
  }))), /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, {
    shrink: true
  }, /*#__PURE__*/_react.default.createElement(_dropDown.default, {
    active: active,
    onActiveChange: setActive,
    trigger: /*#__PURE__*/_react.default.createElement(_button.default, {
      displayType: "secondary",
      monospaced: true,
      onClick: function onClick() {
        return setActive(!active);
      },
      title: ariaLabels.openLocalizations
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: "inline-item"
    }, /*#__PURE__*/_react.default.createElement(_icon.default, {
      spritemap: spritemap,
      symbol: selectedLocale.symbol
    })), /*#__PURE__*/_react.default.createElement("span", {
      className: "btn-section"
    }, selectedLocale.label))
  }, /*#__PURE__*/_react.default.createElement(_dropDown.default.ItemList, null, locales.map(function (locale) {
    var value = translations[locale.label];
    return /*#__PURE__*/_react.default.createElement(_dropDown.default.Item, {
      key: locale.label,
      onClick: function onClick() {
        return onSelectedLocaleChange(locale);
      }
    }, /*#__PURE__*/_react.default.createElement(_layout.default.ContentRow, {
      containerElement: "span"
    }, /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
      containerElement: "span",
      expand: true
    }, /*#__PURE__*/_react.default.createElement(_layout.default.ContentSection, null, /*#__PURE__*/_react.default.createElement(_icon.default, {
      className: "inline-item inline-item-before",
      spritemap: spritemap,
      symbol: locale.symbol
    }), locale.label)), /*#__PURE__*/_react.default.createElement(_layout.default.ContentCol, {
      containerElement: "span"
    }, /*#__PURE__*/_react.default.createElement(_layout.default.ContentSection, null, /*#__PURE__*/_react.default.createElement(_label.default, {
      displayType: locale.label === defaultLanguage.label ? 'info' : value ? 'success' : 'warning'
    }, locale.label === defaultLanguage.label ? ariaLabels.default : value ? ariaLabels.translated : ariaLabels.untranslated)))));
  }))))), /*#__PURE__*/_react.default.createElement(_form.default.Text, null, resultFormatter(translations[defaultLanguage.label])));
});

ClayLocalizedInput.displayName = 'ClayLocalizedInput';
var _default = ClayLocalizedInput;
exports.default = _default;